import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { useCountdown } from '../hooks/useCountdown';
export function ScarcitySection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-10 relative overflow-hidden bg-background-dark border-y border-card-border-dark" data-id="element-341">
      <div className="absolute inset-0 bg-gradient-to-b from-urgency/5 to-transparent pointer-events-none" data-id="element-342" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-343">
        <FadeIn className="text-center" data-id="element-344">
          <h2 className="text-xl md:text-2xl font-bold text-white uppercase tracking-wider mb-8" data-id="element-345">
            ⏰ EL PRECIO PROMOCIONAL TERMINA EN:
          </h2>

          <div className="flex justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-346">
            <div className="flex flex-col items-center" data-id="element-347">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-348">
                {hours}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-349">
                HS
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-urgency/50 pb-6" data-id="element-350">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-351">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-352">
                {minutes}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-353">
                MIN
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-urgency/50 pb-6" data-id="element-354">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-355">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-356">
                {seconds}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-357">
                SEG
              </span>
            </div>
          </div>

          <p className="text-xl md:text-2xl font-bold text-white mb-10" data-id="element-358">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-lg mx-auto" data-id="element-359">
            <div className="flex justify-between items-center mb-2" data-id="element-360">
              <div className="flex items-center gap-2" data-id="element-361">
                <span className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse" data-id="element-362" />
                <span className="text-primary font-medium text-sm" data-id="element-363">
                  Cupos al precio promocional
                </span>
              </div>
              <span className="text-white font-bold text-sm" data-id="element-364">Quedan pocos</span>
            </div>

            <div className="h-3 w-full bg-card-border-dark rounded-full overflow-hidden mb-2" data-id="element-365">
              <div className="h-full bg-primary rounded-full" style={{
              width: '65%'
            }} data-id="element-366" />
            </div>

            <div className="text-right" data-id="element-367">
              <span className="text-gray-400 text-xs" data-id="element-368">
                Precio promocional activo por tiempo limitado
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}